type AsyncFunc = () => Promise<any>;

export default class DebounceAsync {
    private active: Promise<any> = Promise.resolve(null);
    private runningCount: number = 0;
    public get isRunning(): boolean {
        return this.runningCount > 0;
    }

    private async wait() {
        try {
            await this.active;
        } catch {}
    }

    public async invoke(func: AsyncFunc) {
        try {
            this.runningCount++;
            await this.wait();

            if (this.runningCount > 1) {
                return null;
            }

            this.active = func();
            return await this.active;
        } finally {
            this.runningCount--;
        }
    }
}
